import { ShieldAlert } from "lucide-react";

import { CARD_WALL_RADIUS } from "@/shared/ui/cardWall";
import { cn } from "@/shared/lib/utils";

import type { DomainCard } from "../../api/types";
import { DomainStatusChain } from "./DomainStatusChain";

/** 「去哪里改 DNS」四条:图文指引还没写,不挂假链接(`href="#"` 点了回页顶,比没有更糟)。 */
const DNS_PROVIDERS = [
  "阿里云 · 云解析 DNS",
  "腾讯云 · DNSPod",
  "华为云 · 云解析",
  "其他服务商(通用步骤)",
] as const;

/**
 * 屏 5 右栏:域名状态链(读主域名那张卡;没绑自有域名时整链灰)+ 备案提醒 + 去哪里改 DNS。
 * 纯展示,不发请求。
 */
export function DomainAside({
  card,
  simulated = false,
  hostNote = null,
}: {
  card: DomainCard | null;
  /** 模拟发布(A.38):状态链不说「证书」。 */
  simulated?: boolean;
  /** host 模式宿主签发状态人话(A.54)。 */
  hostNote?: string | null;
}) {
  return (
    <aside className="space-y-4" aria-label="域名说明">
      <DomainStatusChain card={card} simulated={simulated} hostNote={hostNote} />

      <section
        aria-label="备案提醒"
        className={cn("border border-warning/40 bg-warning/5 p-4", CARD_WALL_RADIUS)}
      >
        <h2 className="flex items-center gap-1.5 text-sm font-semibold text-foreground">
          <ShieldAlert className="h-4 w-4 text-warning" aria-hidden />
          备案提醒
        </h2>
        <p className="mt-2 text-xs leading-relaxed text-muted-foreground">
          自有域名若要在中国大陆节点访问,需先完成 ICP 备案;没备案的域名先用平台预览域名对外。
        </p>
      </section>

      <section
        aria-label="去哪里改 DNS"
        className={cn("border border-border bg-card p-4", CARD_WALL_RADIUS)}
      >
        <h2 className="text-sm font-semibold text-foreground">去哪里改 DNS</h2>
        <ul className="mt-2 divide-y divide-border">
          {DNS_PROVIDERS.map((name) => (
            <li key={name} className="flex items-center justify-between gap-2 py-2 text-xs">
              <span className="text-foreground">{name}</span>
              <span
                role="link"
                aria-disabled="true"
                aria-label={`${name} 图文指引`}
                title="指引待补"
                className="shrink-0 cursor-not-allowed text-muted-foreground/70"
              >
                图文指引 ↗
              </span>
            </li>
          ))}
        </ul>
      </section>
    </aside>
  );
}
